<template>
    <FormItem>
        <template #question>Registration Details</template>
        <template #response>
            <!--<div class="flex flex-col pa-4 gap-4">
                <div class="row">
                    <div class="justify-start flex">
                        {{ deposit.product.name }}
                    </div>
                    <v-spacer />
                    <div class="justify-end flex">
                        {{ formatUnitAmount(deposit.unit_amount) }}
                    </div>
                </div>
                <div class="row">
                    <div class="justify-start flex">
                        {{ tuition.product.name }}
                    </div>
                    <v-spacer />
                    <div class="justify-end flex">
                        {{ formatUnitAmount(tuition.unit_amount) }}
                    </div>
                </div>
            </div>-->
            <v-list class="pa-0">
                <v-list-item class="px-2" two-line>
                    <v-list-item-content>
                        <v-list-item-title class="justify-start flex">{{
                            tuition.product.name
                        }}</v-list-item-title>
                        <v-list-item-subtitle class="justify-start flex">
                            Due 30 days before camp
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                        <div>
                            {{
                                formatUnitAmount(
                                    tuition.unit_amount - deposit.unit_amount
                                )
                            }}/person
                        </div>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="px-2" two-line>
                    <v-list-item-content>
                        <v-list-item-title class="justify-start flex">{{
                            deposit.product.name
                        }}</v-list-item-title>
                        <v-list-item-subtitle class="justify-start flex">
                            Due today
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                        <div>
                            {{ formatUnitAmount(deposit.unit_amount) }}/person
                        </div>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </template>
    </FormItem>
</template>

<script>
import FormItem from "../../Components/Form/FormItem.vue";

export default {
    components: {
        FormItem,
    },
    props: {
        errors: {},
        user: {
            type: Object,
            default: () => {},
        },
        groupEvent: {
            type: Object,
            default: () => {},
        },
        deposit: {
            type: Object,
            default: () => {},
        },
        tuition: {
            type: Object,
            default: () => {},
        },
        quantity: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>
